import { SupportedLanguage } from '~/i18n/loadLocale';

export const LANGUAGES: { value: SupportedLanguage; label: string }[] = [
  { value: 'de', label: 'Deutsch (Deutschland)' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français (France)' },
  { value: 'fr-CA', label: 'Français (Canada)' },
];

export const L1_LANGUAGES: { value: SupportedLanguage; label: string }[] = [
  { value: 'zh-CN', label: '中文（简体）' },
  { value: 'zh-TW', label: '中文（繁體）' },
  { value: 'nl-NL', label: 'Nederlands (Nederlands)' },
  { value: 'it-IT', label: 'Italiano (Italia)' },
  { value: 'ja', label: '日本語（日本）' },
  { value: 'ko-KR', label: '한국어（대한민국）' },
  { value: 'pt-BR', label: 'Português (Brasil)' },
];

export const LOCALES = [
  { label: 'System Default', value: 'system-default' },
  { label: 'English (Australia) - en_AU', value: 'en-AU' },
  { label: 'English (Canada) - en_CA', value: 'en-CA' },
  { label: 'English (Hong Kong) - en_HK', value: 'en-HK' },
  { label: 'English (India) - en_IN', value: 'en-IN' },
  { label: 'English (Ireland) - en_IE', value: 'en-IE' },
  { label: 'English (New Zealand) - en_NZ', value: 'en-NZ' },
  { label: 'English (Philippines) - en_PH', value: 'en-PH' },
  { label: 'English (Singapore) - en_SG', value: 'en-SG' },
  { label: 'English (South Africa) - en_ZA', value: 'en-ZA' },
  { label: 'English (United Kingdom) - en_GB', value: 'en-GB' },
  { label: 'English (United States) - en_US', value: 'en-US' },
  { label: 'Español (Argentina) - es_AR', value: 'es-AR' },
  { label: 'Español (Bolivia) - es_BO', value: 'es-BO' },
  { label: 'Español (Chile) - es_CL', value: 'es-CL' },
  { label: 'Español (Colombia) - es_CO', value: 'es-CO' },
  { label: 'Español (Costa Rica) - es_CR', value: 'es-CR' },
  { label: 'Español (Ecuador) - es_EC', value: 'es-EC' },
  { label: 'Español (El Salvador) - es_SV', value: 'es-SV' },
  { label: 'Español (España) - es_ES', value: 'es-ES' },
  { label: 'Español (Estados Unidos) - es_US', value: 'es-US' },
  { label: 'Español (Guatemala) - es_GT', value: 'es-GT' },
  { label: 'Español (Honduras) - es_HN', value: 'es-HN' },
  { label: 'Español (México) - es_MX', value: 'es-MX' },
  { label: 'Español (Nicaragua) es_NI', value: 'es-NI' },
  { label: 'Español (Panamá) - es_PA', value: 'es-PA' },
  { label: 'Español (Paraguay) - es_PY', value: 'es-PY' },
  { label: 'Español (Perú) - es_PE', value: 'es-PE' },
  { label: 'Español (Puerto Rico) - es_PR', value: 'es-PR' },
  { label: 'Español (República Dominicana) - es_DO', value: 'es-DO' },
  { label: 'Español (Uruguay) - es_UY', value: 'es-UY' },
  { label: 'Español (Venezuela) - es_VE', value: 'es-VE' },
  { label: 'Français (Belgique) fr_BE', value: 'fr-BE' },
  { label: 'Français (Canada) - fr_CA', value: 'fr-CA' },
  { label: 'Français (France) - fr_FR', value: 'fr-FR' },
  { label: 'Français (Luxembourg) fr_LU', value: 'fr-LU' },
  { label: 'Français (Suisse) fr_CH', value: 'fr-CH' },
  { label: 'Deutsch (Belgien) de_BE', value: 'de-BE' },
  { label: 'Deutsch (Deutschland) de_DE', value: 'de-DE' },
  { label: 'Deutsch (Luxembourg) de_LU', value: 'de-LU' },
  { label: 'Deutsch (Schweiz) de_CH', value: 'de-CH' },
  { label: 'Deutsch (Österreich) de_AT', value: 'de-AT' },
  { label: 'Nederlands (België) - nl_BE', value: 'nl-BE' },
  { label: 'Nederlands (Nederland) - nl_NL', value: 'nl-NL' },
  { label: 'Italiano (Italia) - it_IT', value: 'it-IT' },
  { label: 'Italiano (Svizzera) - it_CH', value: 'it-CH' },
  { label: 'Português (Brasil) - pt_BR', value: 'pt-BR' },
  { label: 'Português (Portugal) - pt_PT', value: 'pt-PT' },
  { label: '日本語 (日本) - ja_JP', value: 'ja-JP' },
  { label: '简体中文 (中国) - zh_CN', value: 'zh-CN' },
  { label: '繁體中文 (台灣) - zh_TW', value: 'zh-TW' },
];
